module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/.store/core-js@2.6.12/~/core-js/library/modules/_library.js
// module id = 22
// module chunks = 0